"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { MovieStatusMessage } from "@/components/movies/MovieStatusMessage";
import { getLanguageFromPathname } from "@/lib/i18n/paths";
import { createTranslator } from "@/lib/i18n/translations";
import { logError } from "@/lib/logger";

export default function MoviesError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  const pathname = usePathname();
  const lang = getLanguageFromPathname(pathname);
  const t = createTranslator(lang);
  const isMoviePage = /^\/[a-z]{2}\/movies\/[^/]+/.test(pathname ?? "");

  useEffect(() => {
    logError("Movies page error", error, {
      component: "MoviesErrorBoundary",
      digest: error.digest,
      page: pathname,
    });
  }, [error, pathname]);

  return (
    <MovieStatusMessage
      action={{ label: t("movies.tryAgain"), onPress: retry }}
      description={
        isMoviePage
          ? t("movieDetail.errorDescription")
          : t("movies.errorDescription")
      }
      icon="⚠️"
      link={
        isMoviePage
          ? { href: `/${lang}/movies`, label: t("movieDetail.backToMovies") }
          : undefined
      }
      title={isMoviePage ? t("movieDetail.errorTitle") : t("movies.errorTitle")}
    />
  );
}
